import Model from '@ember-data/model';

// Same as dataitem but with one item per address, with a count
export default class DatasetItem extends Model {}
